import { createFileRoute, redirect } from '@tanstack/react-router';

// FPD-028 — drilldown stub. No per-contribution detail page exists today;
// the workspace's `?status=staged` pivot at the match view is the closest
// surface where treasurers inspect individual contributions. The id is
// preserved as a search param so a future per-row detail panel can read it
// without breaking bookmarks.
export const Route = createFileRoute('/admin/finance/contributions/$contributionId')({
  beforeLoad: ({
    params,
    search,
  }: {
    params: { contributionId: string };
    search: Record<string, unknown>;
  }) => {
    throw redirect({
      to: '/admin/finance/transactions',
      search: {
        ...search,
        status: 'staged' as const,
        view: 'match' as const,
        contributionId: params.contributionId,
      },
    });
  },
});
